import styled from 'styled-components';

interface IProps {
  ml?: number;
}

export const SocialActivityActionWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: none;
  border-top: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SocialButtonsContainer = styled.div`
  /* height: 24px; */
`;

export const SocialButtonContainer = styled.div<IProps>`
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-left: ${({ ml }) => (ml ? `${ml}px` : '0')};
  cursor: pointer;
`;

export const OutlinedLikeIconWrap = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.orange};
`;
